import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'generateKey',
    pure: true,
    standalone: true,
})
export class GenerateKeyPipe implements PipeTransform {
    transform(
        baseKey: string,
        optionalKey: string | undefined,
        suffix: string,
    ): string {
        return optionalKey
            ? `${baseKey}_${optionalKey}_${suffix}`
            : `${baseKey}_${suffix}`;
    }
}
